module.exports = __webpack_public_path__ + "img/img2_6.135e5eac.jpeg";